import { isDefined } from "@clipboard-health/util-ts";
import { DialogContent, Stack } from "@mui/material";
import { useFacilityProfile } from "@src/appV2/Facilities/api/useFacilityProfile";
import { List } from "@src/appV2/redesign/system/ui-components";
import { useGetRatingAggregates } from "@src/appV2/redesign/Workplace/Review/api/useGetRatingAggregates";

import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";
import { RATING_AGGREGATE_EMPTY } from "../../Workplace/Review/constants";
import { CaseNotesListItem } from "./CaseNotesListItem";
import { InHomeAgencyDetailsListItem } from "./InHomeAgencyDetailsListItem";
import { VisitBottomSheetInnerCardCarousel } from "./InnerCard/InnerCardCarousel";
import { PatientLocationListItem } from "./PatientLocationListItem";
import { VisitBottomSheetSkeleton } from "./Skeleton";
import { VisitDetailsListItem } from "./VisitDetailsListItem";

export function VisitBottomSheetContent() {
  const { isVisitLoading, visit, patient, case: caseData } = useInHomeVisitModalsDataContext();
  const { data: facilityRatings = RATING_AGGREGATE_EMPTY, isLoading: isLoadingRatings } =
    useGetRatingAggregates(caseData?.attributes.workplaceId ?? "", {
      enabled: isDefined(caseData?.attributes.workplaceId),
    });

  const { data: facility, isLoading: isLoadingFacility } = useFacilityProfile(
    { workplaceId: caseData?.attributes.workplaceId ?? "" },
    {
      enabled: isDefined(caseData?.attributes.workplaceId),
    }
  );

  const isShowSkeleton =
    isVisitLoading ||
    isLoadingRatings ||
    isLoadingFacility ||
    !isDefined(visit) ||
    !isDefined(patient) ||
    !isDefined(caseData) ||
    !isDefined(facilityRatings) ||
    !isDefined(facility);

  return (
    <DialogContent
      sx={{
        backgroundColor: (theme) => theme.palette.background.tertiary,
        overflowY: "auto",
      }}
    >
      <Stack
        sx={{
          height: "100%",
        }}
      >
        {isShowSkeleton && <VisitBottomSheetSkeleton />}
        {!isShowSkeleton && (
          <List>
            <VisitBottomSheetInnerCardCarousel visit={visit} />
            <VisitDetailsListItem visit={visit} />
            <CaseNotesListItem caseData={caseData} />
            <PatientLocationListItem
              patient={patient}
              workplaceId={caseData.attributes.workplaceId}
              isBooked={false}
            />
            <InHomeAgencyDetailsListItem facilityRatings={facilityRatings} facility={facility} />
          </List>
        )}
      </Stack>
    </DialogContent>
  );
}
